// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2971f5e","455":"4077086b"}[chunkId] + ".chunk.js";
};